import React, { useState, useEffect } from 'react';
import { Roadmap } from '../Models/Roadmap';
import { useAppDispatch, useAppSelector } from '../Core/hooks';
import { getAllProjectCardsForRoadmap, getAllProjectListsForRoadmap, 
    getDash, setDash, setFromDate, setSelectedProjectId, setToDate, showDashButtons } from '../Store/Dash';
import { AiOutlinePlus,  AiOutlineMinus } from 'react-icons/ai';
import RoadmapDashFunnel from './RoadmapDashFunnel';
import RoadmapDashBar from './RoadmapDashBar';
import { getProject } from '../Store/Project';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { Link } from 'react-router-dom';
import RoadmapDashWorkList from './RoadmapDashWorkList';
import { useIsMobile } from '../Core/hooks';

interface Props {
    roadmap: Roadmap;
}

function RoadmapDash(props: Props) {

    const dispatch = useAppDispatch();
    let dashState = useAppSelector(getDash);
    let projectState= useAppSelector(getProject);
    const [selectedProject, setSelectedProject] = useState("");
    const [errorMessage, setErrorMessage] = useState<string>("");
    const isMobile = useIsMobile();

    // on refresh / initial load
    useEffect(() => {
        dispatch(getAllProjectListsForRoadmap(props.roadmap._id));
        dispatch(getAllProjectCardsForRoadmap(props.roadmap._id));
    }, [])

    const toggleDashButtons = (show: boolean) => {
        dispatch(showDashButtons(show));
    }

    const showError = (error: string) => {
        //setError(true);
        setErrorMessage(error);
        //setFormSubmitted(false);
        setTimeout(() => setErrorMessage(""), 2000);
    }

    const handleToDate = (date: Date | null) => {
        if (date) {
            if (dashState.fromDate) {
                if (date < dashState.fromDate) {
                    showError("The To Date must be >= From Date");
                } else {
                    dispatch(setToDate(date));
                }
            } else {
                dispatch(setToDate(date));
            }
        }
    }

    const handleFromDate = (date: Date | null) => {
        if (date) {
            if (dashState.toDate) {
                if (date > dashState.toDate) {
                    showError("The From Date must be < To Date");
                } else {
                    dispatch(setFromDate(date));
                }
            } else {
                dispatch(setFromDate(date));    
            }
        }
    }

    const clearFilters = () => {
        dispatch(setSelectedProjectId(""));
        dispatch(setFromDate(null));
        dispatch(setToDate(null));
    }
   
    /*
    const handleSelectedProject = (e: React.ChangeEvent<HTMLSelectElement>) => {
        dispatch(setSelectedProjectId(e.currentTarget.value));
    }
    */
    const WORK_FUNNEL = "workFunnel";
    const PROJECT_BAR_CHART = "projectBarChart";
    const WORK_LIST = "workList";
    let dash = dashState.dash;

    let projectOptions = projectState.projects
    .slice() // create a copy to avoid mutating state
    .sort((a, b) => a.name.localeCompare(b.name))
    .map(project => (
      <option key={project._id} value={project._id} selected={project._id === dashState.selectedProjectId}>
        {project.name}
      </option>
    ));
    
    return (
        <div className="rightContentDefault" 
        style={{
            overflowY: "auto",
            ...(isMobile
            ? {
                padding: "0px 15px 15px 25px", 
                }
            : {
                padding: "20px 25px 15px 25px",
            }),
        }}>
            {dashState.showDashButtons &&
                <div style={{ 
                    marginBottom: "10px", 
                    fontSize: "11pt", 
                    overflowX: "auto", 
                    whiteSpace: "nowrap" 
                  }}>
                    <div 
                        onClick={() => dispatch(setDash(WORK_FUNNEL))}
                        style={{ display: "inline-block", cursor: "pointer", width: "150px", backgroundColor: "#efefef", 
                        padding: "2px 10px", borderRadius: "30px", textAlign: "center",
                        ...(dash === WORK_FUNNEL) && { backgroundColor: "#000" },
                        ...(dash === WORK_FUNNEL) && { color: "#fff" },
                        ...(dash === WORK_FUNNEL) && { fontWeight: 500 },
                    }}>
                        Work Funnel
                    </div>
                    <div 
                        onClick={() => dispatch(setDash(PROJECT_BAR_CHART))}
                        style={{ marginLeft: "10px", display: "inline-block", cursor: "pointer", width: "150px", backgroundColor: "#efefef", 
                        padding: "2px 10px", borderRadius: "30px", textAlign: "center",
                        ...(dash === PROJECT_BAR_CHART) && { backgroundColor: "#000" },
                        ...(dash === PROJECT_BAR_CHART) && { color: "#fff" }, 
                        ...(dash === PROJECT_BAR_CHART) && { fontWeight: 500 },
                    }}>
                        Work Barchart
                    </div>
                    <div 
                        onClick={() => dispatch(setDash(WORK_LIST))}
                        style={{ marginLeft: "10px", display: "inline-block", cursor: "pointer", width: "200px", backgroundColor: "#efefef", 
                        padding: "2px 10px", borderRadius: "30px", textAlign: "center",
                        ...(dash === WORK_LIST) && { backgroundColor: "#000" },
                        ...(dash === WORK_LIST) && { color: "#fff" }, 
                        ...(dash === WORK_LIST) && { fontWeight: 500 },
                    }}>
                        Done Work By Person
                    </div>
                </div>
            }

            {errorMessage !== "" &&
                <div className="error2" style={{ marginTop: "10px", marginBottom: "10px" }}>
                    {errorMessage}
                </div>
            }

            <div style={{ 
                display: "flex", 
                justifyContent: "left", 
                alignItems: "center", 
                gap: "10px", 
            }}>
                {!dashState.showDashButtons ?
                    <div style={{
                        display: "inline-flex", backgroundColor: "#efefef",
                        alignItems: "center", justifyContent: "center", top: "0px",
                        borderRadius: "50%", padding: "2px", height: "28px", width: "28px",
                        position: "relative", textAlign: "center", cursor: "pointer"
                    }}
                        onClick={() => toggleDashButtons(true)}>
                        <AiOutlinePlus size={16} />
                    </div>
                :
                    <>
                    {!isMobile &&
                        <div style={{
                            display: "inline-flex", backgroundColor: "#efefef",
                            alignItems: "center", justifyContent: "center", top: "0px",
                            borderRadius: "50%", padding: "2px", height: "28px", width: "28px",
                            position: "relative", textAlign: "center", cursor: "pointer"
                        }}
                            onClick={() => toggleDashButtons(false)}>
                            <AiOutlineMinus size={16} />
                        </div>
                    }
                    </>
                }
                <div 
                style={{
                    ...(isMobile
                    ? {
                        display: "block",
                        textAlign: "center",
                        width: "100%",
                        }
                    : {
                        display: "flex",
                        alignItems: "center"
                    }),
                }}>
                    <div style={{
                        ...(isMobile
                        ? {

                            }
                        : {
                            marginRight: "5px"
                        }),
                    }}>
                        <select onChange={(e) => dispatch(setSelectedProjectId(e.currentTarget.value))} 
                            value={dashState.selectedProjectId}
                            className="form-control-custom-1">
                            <option value="">Select a Project</option>
                            {projectOptions}
                        </select>
                    </div>
                    <div style={{
                        ...(isMobile
                        ? {
                            marginTop: "10px"
                          }
                        : {
                            marginRight: "5px"
                        }),
                    }}>
                        <DatePicker selected={dashState.fromDate} onChange={(date) => handleFromDate(date)}
                            className="datepicker-control-custom-1" placeholderText="From" withPortal />
                    </div>
                    <div style={{
                        ...(isMobile
                        ? {

                            }
                        : {
                            marginRight: "5px"
                        }),
                    }}>
                        <DatePicker selected={dashState.toDate} onChange={(date) => handleToDate(date)}
                            className="datepicker-control-custom-1" placeholderText="To" withPortal />
                    </div>
                    <div>
                        <Link to="" onClick={() => clearFilters()} style={{ color: "#000", fontSize: "10pt" }}>
                            Clear
                        </Link>
                    </div>
                </div>
            </div>

            {dash === WORK_FUNNEL &&
                <RoadmapDashFunnel />
            }
            {dash === PROJECT_BAR_CHART &&
                <RoadmapDashBar />
            }
            {dash === WORK_LIST &&
                <RoadmapDashWorkList />
            }
        </div>
    );
}

export default RoadmapDash;
